import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '@/lib/api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success(t('auth.resetEmailSent'));
    } catch {
      toast.error(t('auth.resetEmailFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-8">
        <div className="lg:hidden flex items-center gap-2 mb-6">
          <img src="/logo.svg" alt="Ledgora" className="w-10 h-10" />
          <span className="text-xl font-bold text-gray-900">{import.meta.env.VITE_APP_NAME}</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900">{t('auth.forgotPassword')}</h2>
        <p className="mt-2 text-sm text-gray-600">
          {t('auth.forgotPasswordDescription')}
        </p>
      </div>

      {sent ? (
        <div className="rounded-lg bg-green-50 border border-green-200 p-4 text-sm text-green-800">
          <p className="font-medium mb-1">{t('auth.resetEmailSent')}</p>
          <p className="text-green-600">{t('auth.checkInbox')}</p>
          <Link to="/login" className="mt-4 inline-block text-primary-600 hover:text-primary-500 font-medium text-sm">
            ← {t('auth.backToLogin')}
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="email" className="label">{t('auth.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              required
              autoFocus
              placeholder="you@example.com"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
          >
            {loading ? t('common.loading') : t('auth.sendResetLink')}
          </button>

          <div className="text-center">
            <Link to="/login" className="text-sm text-primary-600 hover:text-primary-500 font-medium">
              ← {t('auth.backToLogin')}
            </Link>
          </div>
        </form>
      )}
    </div>
  );
}
